<template>
  <div
    id="paper"
    v-if="data"
    :class="{ has_image: data.image }"
    @scroll="onScroll()"
  >
    <vue-headful
      :title="'Edgeryders | ' + data.title"
      :description="data.title"
      :image="data.image_url"
    />
    <Menu :account="account" :menu="menu" :header="header" :views="views" />

    <div v-if="config && config.template == 'read'">
      <Header :data="data"  />

      <main>
        <Sidebar :words="words" :data="data" :raw="raw" v-if="config.sidebar !== false"/>

        <Content :json="json" :data="data" :text="text" :comments="comments" :config="config" />
      </main>
    </div>

    <div>

      <SiteHeader :data="data" :header="header" :logos="logos"  />

      <main class="site">
        <Site :views="views" :data="data" :json="json" :text="text" :config="config" />
      </main>

      <Footer />
    </div>



  </div>
</template>

<script>
import moment from "moment";
import forge from "node-forge";
import Footer from "./elements/footer.vue";
import Menu from "./elements/menu.vue";
import Header from "./elements/header.vue";
import Sidebar from "./elements/sidebar.vue";
import Content from "./elements/content.vue";
import Site from "./templates/site/content.vue";
import SiteHeader from "./templates/site/header.vue";

export default {
  name: "App",
  data() {
    return {
      data: null,
      topic_data: null,
      download: false,
      words: null,
      html: null,
      comments: [],
      pem: null,
      privateKey: null,
      loginUrl: null,
      apikey: null,
      nonce: null,
      account: null,
      post_url: null,
      error: null,
      progress: null,
    };
  },
  components: {
    Menu,
    Header,
    Sidebar,
    Content,
    Site,
    SiteHeader,
    Footer
  },
  props: ["id", "json", "header", "logos", "project", "menu", "raw", "text", "config", "views"],
  methods: {
    handleScroll() {
      let menu = document.querySelector(".menu");
      var height = 150;
      if (window.scrollY > height) {
        menu.classList.add("active");
      } else {
        menu.className = "menu";
      }
    },
    convertJson(text) {
      var html = text.replace("/n", "").replace(/\n/g, "");
      const doc = new DOMParser().parseFromString(
        "<body>" + html + "</body>",
        "text/xml"
      );
      var main = doc.querySelector("body").childNodes;
      var array = Array.prototype.slice.call(main);
      this.json = array.map((x) => x.outerHTML);
    },
    getComment(text) {
      var html = text
        .replace("/n", "")
        .replace("<p>", "")
        .replace("</p>", "")
        .replace(/\n/g, "");

      var obj = {
        text: html,
      };

      const doc = new DOMParser().parseFromString(html, "text/html");
      const quote = doc.querySelectorAll("aside");
      // console.log(quote.childNodes);
      if (quote && quote[0]) {
        obj["text"] = quote[0].nextElementSibling.innerText;
        const blockquote = doc
          .querySelectorAll("blockquote")[0]
          .innerText.replace(/\n/g, "");
        obj["quote"] = blockquote;
      }

      return obj;
    },
    getComments(posts) {
      var i;
      for (i = 1; i < posts.length; i++) {
        var data = posts[i];
        var comment = this.getComment(data.cooked);
        var obj = {
          text: comment.text,
          date: data.created_at,
          id: data.post_number,
          username: data.username,
          quote: null,
          avatar_template:
            "https://edgeryders.eu" +
            data.avatar_template.replace("{size}", 200),
        };
        if (data.reply_count !== 0) {
          obj["replies"] = true;
        }
        if (comment.quote) {
          obj["quote"] = comment.quote;
        }
        if (data.reply_to_post_number !== null) {
          obj["reply_to"] = data.reply_to_post_number;
        }

        this.comments.push(obj);
      }
    },
    parseText(text) {
      var regex = /^![[^]]*]\((?<filename>.*?)(?="|\))(?<optionalpart>".*")?\)/g;
      return window.md.render(text.replace(regex, ""));
    },
    wordCount(text) {
      return text.split(" ").length;
    },
    formatDate(value) {
      return moment(String(value)).format("dddd, MMMM Do YYYY");
    },
    createLogin() {
      var applicationName = "Edgeryders Webkit";
      var scopes = "read,write";

      var ClientId_raw = crypto.getRandomValues(new Uint8Array(30));
      var randomClientId = toBase64URL(btoa(ab2str(ClientId_raw)));

      var redirectUrl =
        window.location.href.replace(/\/+$/, "") + "/auth_redirect";
      console.log(redirectUrl);

      function ab2str(buf) {
        return String.fromCharCode.apply(null, new Uint8Array(buf));
      }
      function toBase64URL(base64) {
        return base64
          .replace(/=/g, "")
          .replace(/\+/g, "-")
          .replace(/\//g, "_");
      }
      // var forgeKeypair = forge.pki.rsa.generateKeyPair({bits: 2048, e: 0x10001});

      var pem =
        "-----BEGIN RSA PRIVATE KEY----- MIIEpAIBAAKCAQEA08/hMLzcR5pdTGKb09MpnUZTM8GGMii+ow3dmcs5Zvlyz0Ib fxrYhq8h1Jm1/SBvErY+Jj0YB1O9WjaGQNvL8dFukUB2bAYE9IraWvc2GJyljIqi 2dPDc7eTR+v55Ofh2ZYjr18xK9TlsCAwJm9SRR6orMHK1vzosuPgbiAainXyC6ru tTcW5iiDhM/1VatzxK6tXC1W01ScREke+BEG6Vaca8No4cPm8CTidtVlvYgebH1E SM7dY2BQJkE+HFHXp8jIsP8x6k2GZyX8n7wROkzZrfI/YTspGcLJFDRdfUKodkCM d8fEgSOMNqDb/ur2BOHETsSmKESEjMv5jA4dswIDAQABAoIBAQC97bPRzigAFM0A R5PPV5QDMSI+UJQSujJnZ3GEDJUGXzux2WdqjBoIe1Xsm4By3/h5YO1NwI6hU1eB Y07zLaQszE1G9fS6XJNo7HFsDCx32U8hPNdWV+r1AnGQlmrX9Y2xXE3XXZZr5VWo ntROQpgU3q8FaiiGqvXGI0wFs8fYytRCwOMlKGVcWa7K3r5aiuwllRuiyqx7hz11 x6W4y3sgWRLpIh1W9qXk3Vo9/uMGX6yGUVyAxgI/y9TacwsUHrNUuO+ALQhz+4tF l8ChzF8KKnIlWG3Bbhix7UguO7gzKmw/Jsf38WpqqvtJlcpS2bOeriQsP5KesXXs MONG6/IBAoGBAPF9qa0p1dg+49E3/+xuV8PP3Ow4zw6tNbqq+X+1ELfml1GEP6Qm /magnGRupv6tis2NPhf/LTUwB2T8nFn2TRVQL3N3OfNPzHTKxUZ3ta8UH3nqHd0j rE6gdLO/B2FO/UygLMkrFymEMcsCYUjeNs0IxKnYU6FwXTrHampL6AuBAoGBAOCJ uxO+FrcwGAxtvUED7upRvdvDmVIvUn+l9O+HO4B48vp+33T85kqZoLMYE6IegGRR hUvnn0Gy2JSRVQ94hvGrzec+H9oeG1g6xpGTDctKHCOs9O3OlB1/yYfTeQ1d35lb calb9zFUucJwVXp38S44KVLFHdzC99ApxZ3RmVMzAoGBAJEwRhVQM7uBhCLDkmCp rqaRkHeNaB+gz87dAIhhah3Gy289Ha4pq4Y0RhKz3D7+Q5d1tcFjr+BsceWrYq1L wehwfzbilbrNXVVSm+zUCC2s4YfA1BeiXPQg0ElJLry4at3o50RDXfed/PnbAnZ2 82euP98FqrJDBipSvo4N+QMBAoGAG02EGv11Q6csdW5uodY5mfKAlJVvMkggzva+ FtYpzRBn8z+0KkSKOC4AFWbrFD6DPC+Rds5eVh3KKh6V6kCsn/xVGDY8p0gb6RmU haUM+1gynb/tNHF3HzMnrUVwpchxZPNymbZeE3iK8fK44iBtikI3/CGN5QcsHPrH Vc5jx3MCgYB7l60OR55LkkdlG+p9uqEkbc439rMjcT8AtV8JpwJ5q5MkGF+Z8bBp F1KVJLWcUXXjmrEE+yAeoSvGDgQPukkobRRLeno4iKpO6pacq4jxRvlJooNoAXRj +yJGiXWEbakLuGAgN7okTqQ56XTaPNwVxTnx61p1BH8h8Z66TgeG2Q== -----END RSA PRIVATE KEY-----";

      var privKey = forge.pki.privateKeyFromPem(pem);
      this.privateKey = privKey;
      var pubKey = forge.pki.rsa.setPublicKey(privKey.n, privKey.e);

      this.pem = forge.pki.publicKeyToPem(pubKey).replace(/\r/g, "");

      const url = new URL("https://edgeryders.eu");
      url.pathname = "/user-api-key/new";
      url.searchParams.set("auth_redirect", redirectUrl);
      url.searchParams.set("application_name", applicationName);
      url.searchParams.set("client_id", randomClientId);
      url.searchParams.set("scopes", scopes);
      url.searchParams.set("public_key", this.pem);
      url.searchParams.set("nonce", this.comment.text);

      this.loginUrl = url.href;
    },
    decrypt(payload) {
      var pem =
        "-----BEGIN RSA PRIVATE KEY----- MIIEpAIBAAKCAQEA08/hMLzcR5pdTGKb09MpnUZTM8GGMii+ow3dmcs5Zvlyz0Ib fxrYhq8h1Jm1/SBvErY+Jj0YB1O9WjaGQNvL8dFukUB2bAYE9IraWvc2GJyljIqi 2dPDc7eTR+v55Ofh2ZYjr18xK9TlsCAwJm9SRR6orMHK1vzosuPgbiAainXyC6ru tTcW5iiDhM/1VatzxK6tXC1W01ScREke+BEG6Vaca8No4cPm8CTidtVlvYgebH1E SM7dY2BQJkE+HFHXp8jIsP8x6k2GZyX8n7wROkzZrfI/YTspGcLJFDRdfUKodkCM d8fEgSOMNqDb/ur2BOHETsSmKESEjMv5jA4dswIDAQABAoIBAQC97bPRzigAFM0A R5PPV5QDMSI+UJQSujJnZ3GEDJUGXzux2WdqjBoIe1Xsm4By3/h5YO1NwI6hU1eB Y07zLaQszE1G9fS6XJNo7HFsDCx32U8hPNdWV+r1AnGQlmrX9Y2xXE3XXZZr5VWo ntROQpgU3q8FaiiGqvXGI0wFs8fYytRCwOMlKGVcWa7K3r5aiuwllRuiyqx7hz11 x6W4y3sgWRLpIh1W9qXk3Vo9/uMGX6yGUVyAxgI/y9TacwsUHrNUuO+ALQhz+4tF l8ChzF8KKnIlWG3Bbhix7UguO7gzKmw/Jsf38WpqqvtJlcpS2bOeriQsP5KesXXs MONG6/IBAoGBAPF9qa0p1dg+49E3/+xuV8PP3Ow4zw6tNbqq+X+1ELfml1GEP6Qm /magnGRupv6tis2NPhf/LTUwB2T8nFn2TRVQL3N3OfNPzHTKxUZ3ta8UH3nqHd0j rE6gdLO/B2FO/UygLMkrFymEMcsCYUjeNs0IxKnYU6FwXTrHampL6AuBAoGBAOCJ uxO+FrcwGAxtvUED7upRvdvDmVIvUn+l9O+HO4B48vp+33T85kqZoLMYE6IegGRR hUvnn0Gy2JSRVQ94hvGrzec+H9oeG1g6xpGTDctKHCOs9O3OlB1/yYfTeQ1d35lb calb9zFUucJwVXp38S44KVLFHdzC99ApxZ3RmVMzAoGBAJEwRhVQM7uBhCLDkmCp rqaRkHeNaB+gz87dAIhhah3Gy289Ha4pq4Y0RhKz3D7+Q5d1tcFjr+BsceWrYq1L wehwfzbilbrNXVVSm+zUCC2s4YfA1BeiXPQg0ElJLry4at3o50RDXfed/PnbAnZ2 82euP98FqrJDBipSvo4N+QMBAoGAG02EGv11Q6csdW5uodY5mfKAlJVvMkggzva+ FtYpzRBn8z+0KkSKOC4AFWbrFD6DPC+Rds5eVh3KKh6V6kCsn/xVGDY8p0gb6RmU haUM+1gynb/tNHF3HzMnrUVwpchxZPNymbZeE3iK8fK44iBtikI3/CGN5QcsHPrH Vc5jx3MCgYB7l60OR55LkkdlG+p9uqEkbc439rMjcT8AtV8JpwJ5q5MkGF+Z8bBp F1KVJLWcUXXjmrEE+yAeoSvGDgQPukkobRRLeno4iKpO6pacq4jxRvlJooNoAXRj +yJGiXWEbakLuGAgN7okTqQ56XTaPNwVxTnx61p1BH8h8Z66TgeG2Q== -----END RSA PRIVATE KEY-----";

      var privKey = forge.pki.privateKeyFromPem(pem);
      this.privateKey = privKey;

      const cleanPayload = payload.replace(/ /g, "");
      const cypherCode = atob(cleanPayload);
      const decryptCode = this.privateKey.decrypt(
        cypherCode,
        "RSAES-PKCS1-V1_5"
      );
      const result = JSON.parse(decryptCode);
      this.apikey = result;
      this.comment.text = result.nonce;

      this.getUser();
    },
    getUser() {
      var self = this;
      fetch("https://edgeryders.eu/session/current.json", {
        method: "get",
        headers: {
          "User-Api-Key": this.apikey.key,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          self.account = data.current_user;
        });
    },
  },
  mounted() {
    if (process.browser) {
      window.addEventListener("scroll", this.handleScroll);
    }
  },
  filters: {
    formatDate: function(value) {
      return moment(String(value)).format("dddd, MMMM Do YYYY");
    },
    formatTime: function(value) {
      return moment(String(value)).format("hh:mm A");
    },
  },
  created() {
    var self = this;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    // similar behavior as clicking on a link

    const payloadParam = urlParams.get("payload");

    const quote = urlParams.get("quote");

    fetch("https://edgeryders.eu/t/" + this.id + ".json")
      .then((response) => response.json())
      .then((data) => {
        var obj = {
          image: data.image_url,
          title: data.title,
          date: data.created_at,
          name: data.post_stream.posts[0].name,
          username: data.post_stream.posts[0].username,
          avatar:
            "https://edgeryders.eu" +
            data.post_stream.posts[0].avatar_template.replace("{size}", "200"),
          text: data.post_stream.posts[0].cooked,
        };
        this.data = obj;
        this.topic_data = data;
        this.getComments(data.post_stream.posts);
      });

    // fetch("https://edgeryders.eu/raw/" + this.id + ".json")
    //   .then((response) => {
    //     response.text().then(function(text) {
    //       self.raw = self.parseText(text);
    //       self.text = self.raw.replace(/<(.|\n)*?>/g, "");
    //       self.words = self.wordCount(text);
    //       self.convertJson(self.raw);
    //       if (quote) {
    //         var pos = quote.split(",");
    //         self.getQuote(pos[0], pos[1]);
    //       }
    //     });
    //   })
    //   .catch((error) => console.error(error));

    // var temp = require("../assets/data/template.md");
    // window.console.log(temp.default)
    //    self.raw = self.parseText(temp.default);
    //       self.text = self.raw.replace(/<(.|\n)*?>/g, "");
    //       self.words = self.wordCount(temp.default);
    //       self.convertJson(self.raw);

         if (quote) {
            var pos = quote.split(",");
            self.getQuote(pos[0], pos[1]);
          }

    if (payloadParam) {
      const payload = decodeURIComponent(payloadParam);
      this.decrypt(payload);
      this.getUser();
    }
  },
};
</script>
<style lang="scss">

h2 {
  @apply text-2xl;
}

main {
  max-width: 1120px;
  @apply mx-auto flex pr-12;
  &.site {
    padding: 0;
    width: 55%;
  }
}

@media only screen and (max-width: 600px) {
main {
  &.site {
  width: 90%;
}
}
}
</style>
